<template>
  <div class="app-container">
    <div style="display: flex; justify-content: end">
      <el-select
        filterable
        style="float: right; margin-right: 10px"
        v-model="screen.deal_zombie_vehicle"
        placeholder="请选择审核状态"
      >
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        style="float: right; margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
    
    style=" margin-right: 10px;width: 200px;"
        v-model="screen.car_number"
        placeholder="请输入车牌号模糊查询"
      ></el-input>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px; float: right"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; float: right"
        >重置</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park_name ? scope.row.park_name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.car_number }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户姓名" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.user_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户手机号"  width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.user_phone ? scope.row.user_phone : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="进场时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.in_time ? scope.row.in_time : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="停留时间" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.remain_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="僵尸车处理情况" min-width="120">
        <template slot-scope="scope">
          <span>{{
            scope.row.deal_zombie_vehicle == 0
              ? "未处理"
              : scope.row.deal_zombie_vehicle == 1
              ? "已处理"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="examine(scope.row.id)"
            v-if="roles.includes('/carport/order_refund')"
            >查看详情</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="recordOut(scope.row.id)"
            v-if="roles.includes('/zombie_vehicle/set_car_record_out')"
            >置为出场</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      title="详情"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="infoForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="车牌号" prop="head_name">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.car_number"
          ></el-input>
        </el-form-item>

        <el-form-item label="车主姓名">
          <el-input class="w4" disabled v-model="infoForm.user_name"></el-input>
        </el-form-item>
        <el-form-item label="车主手机号" prop="user_phone">
          <el-input
            class="w4"
            disabled
            v-model="infoForm.user_phone"
          ></el-input>
        </el-form-item>
        <el-form-item label="进场图片" prop="title">
          <p v-if="infoForm.in_image">
            <el-image
              :src="infoForm.in_image"
              class="tableIcon"
              fit="contain"
              :preview-src-list="infoForm.in_image.split(',')"
            >
            </el-image>
          </p>
        </el-form-item>
        <el-form-item label="进场时间" prop="area">
          <el-input class="w4" disabled v-model="infoForm.in_time"></el-input>
        </el-form-item>
        <el-form-item label="处理状态" prop="deal_zombie_vehicle">
          <el-radio-group v-model="infoForm.deal_zombie_vehicle" disabled>
            <el-radio :label="0">未处理</el-radio>
            <el-radio :label="1">已处理</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="infoForm.deal_zombie_vehicle == 1">
          <span
            style="
              font-size: 18px;
              font-weight: 600;
              padding-left: 40px;
              margin-bottom: 15px;
              display: inline-block;
            "
            >处理结果</span
          >
          <el-form-item label="处理图片" prop="title">
            <p v-if="infoForm.deal_res.deal_image">
              <el-image
                :src="infoForm.deal_res.deal_image"
                class="tableIcon"
                fit="contain"
                :preview-src-list="infoForm.deal_res.deal_image.split(',')"
              >
              </el-image>
            </p>
          </el-form-item>
          <el-form-item label="处理结果	" prop="deal_mark">
            <el-input
            type="textarea"
              class="w4"
              disabled
              v-model="infoForm.deal_res.deal_mark"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="info" @click="drawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { zombieList, zombieInfo,zombieOut } from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "全部状态",
          id: "-1",
        },
        {
          title: "未处理",
          id: 0,
        },
        {
          title: "已处理",
          id: 1,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        deal_zombie_vehicle: "-1",
        car_number:''
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      infoForm: {},
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      drawer: false,
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
      // 置为出场
      recordOut(id) {
      var that = this;
      this.$confirm("确认置为出场？")
        .then(() => {
          zombieOut({ record_id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    examine(id) {
      zombieInfo({ record_id: id }).then((res) => {
        console.log(res);
        this.infoForm = {
          car_number: res.data.car_number,
          in_time: res.data.in_time,
          user_phone: res.data.user_phone,
          user_name: res.data.user_name,
          in_image: res.data.in_image,
          deal_zombie_vehicle: res.data.deal_zombie_vehicle,
          deal_res: res.data.deal_res,
        };
        this.drawer = true;
        console.log(this.infoForm);
      });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        deal_zombie_vehicle: "-1",
        car_number:''
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      zombieList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
